<template>
	<div class="parking-pay-wrapper">
		<article class="weui-article">
			<section>
				<div class="weui-cell weui-cell_active weui-cell_access  weui-cell_select-after weui-cell_plate">
					<div class="weui-cell__hd"><label class="weui-label">车牌号</label></div>
					<div class="weui-cell__bd weui-cell__plate">{{ park.carNumber || '无' }}</div>

				</div>
			</section>
		</article>
		<article class="weui-article">
			<section>
				<div class="weui-cell weui-cell_active weui-cell_access  weui-cell_select-after weui-cell_park">
					<div class="weui-cell__hd"><label class="weui-label">停车场</label></div>
					<div class="weui-cell__bd">{{ park.parkingLotName || '无' }}</div>
				</div>
			</section>
		</article>

		<article class="weui-article">
			<section>
				<div class="weui-cell weui-cell_active weui-cell_access  weui-cell_select-after">
					<div class="weui-cell__hd"><label class="weui-label">停车时间</label></div>
					<div class="weui-cell__bd">{{ park.duration|| '无' }}分钟</div>

				</div>
			</section>
		</article>
		<article class="weui-article">
			<section>
				<div class="weui-cell weui-cell_active weui-cell_access  weui-cell_select-after">
					<div class="weui-cell__hd"><label class="weui-label">总金额</label></div>
					<!-- {{ parkMoney.rsParkRec.needPayAmount }} -->
					<!-- {{  parkMoney.rsParkRec.payAmount }} -->
					<div class="weui-cell__bd">￥{{ (parkMoney.rsParkRec.needPayAmount +
						parkMoney.rsParkRec.payAmount).toFixed(2) || '无' }}</div>

				</div>
			</section>
		</article>
		<article class="weui-article">
			<section>
				<div class="weui-cell weui-cell_active weui-cell_access  weui-cell_select-after">
					<div class="weui-cell__hd"><label class="weui-label">押金</label></div>
					<div class="weui-cell__bd">￥{{ parkMoney.rsParkRec.cashPledge || '无' }}</div>

				</div>
			</section>
		</article>
		<article class="weui-article">
			<section>
				<div class="weui-cell weui-cell_active weui-cell_access  weui-cell_select-after">
					<div class="weui-cell__hd"><label class="weui-label">已付金额</label></div>
					<div class="weui-cell__bd">￥{{ parkMoney.rsParkRec.payAmount || '无' }}</div>

				</div>
			</section>
		</article>

		<div class="weui-article">
			<div class="weui-form-preview__item">
				<br>

				<label class="color weui-cell__hd">待付金额：</label>


				<label class="weui-cell__hd">¥{{ parkMoney.rsParkRec.needPayAmount }}</label>
			</div>
		</div>
		<!-- <div class="user-info" v-show="spaceMark"> -->
		<!--<p>楼号: A栋</p>-->
		<!--<p>房间号: 3-101室</p>-->
		<!-- <p>车位号: {{spaceMark}}</p> -->
		<!-- </div> -->
		<div class="weui-btn-area">
			<el-button type="primary" class="weui-btn" :class="isDisabled ? 'weui-btn_disabled' : 'weui-btn_primary'"
				:disabled="isDisabled" @click="handlePay">确认缴费</el-button>
			<!-- <el-button class="parkbtn" type="primary" @click="submit">开始停车</el-button> -->
		</div>
	</div>
</template>

<script>
import { getApplyParkOff, getUnionOrder, getManagerOffParkInfo } from "@/api/coupon/admin";


export default {
	name: "index",
	data() {
		return {
			rsParkRecId: "",
			park: "",
			userOpenId: "",
			parkMoney: "",
		}
	},
	computed: {

	},
	mounted() {
		this.userOpenId = localStorage.getItem("userOpenId")
		this.ApplyParkOff()

	},
	methods: {

		

		//用户缴费
		handlePay() {

			let data = {
				orderSn: this.park.orderSn,
				parkinglotId: this.$route.query.lotId,
				payType: 13,
				openId: this.userOpenId
			}
			getUnionOrder(data).then(res => {
				if (res.code == 200) {
					this.RSparkInfo()
					// this.$weui.alert(res.msg)
					this.$pay(res)
				}
			})

		},
		toHoursAndMinutes(totalMinutes) {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;  
  console.log(hours,'hours');
  console.log(minutes,'minutes');

  return { hours, minutes };

},
		ApplyParkOff() {
			let params = {
				id: this.$route.query.rsParkRecId
			}
			getApplyParkOff(params).then(res => {
				this.RSparkInfo()
				console.log(res, '查询付款金额');
				if (res.code == 200) {
					this.park = res.data
					
					
					this.toHoursAndMinutes(	this.park.duration*60)

				}
			})
		},

		RSparkInfo() {
			let params = {
				// lotId: 1,
				lotId: this.$route.query.lotId,
				parkingName: this.$route.query.parkingName
				// parkingName: 9
			}

			getManagerOffParkInfo(params).then(res => {

				if (res.code == 200) {
					this.parkMoney = res.data
					

				} else {
					this.$weui.alert(res.msg)
				}




			})
		},
	}
}
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable'
	.parking-pay-wrapper{
		padding 20px 0
		.weui-article{
			padding-top 0
			padding-bottom 0
			section{
				margin-bottom 0
			}
			.weui-label{
				width 80px
			}
			.weui-cell__plate{
				flex unset
				width 35%
			}
			.weui-cell__plate:after{
				right 45%
			}
			.weui-cell_select-after{
				padding-left 0
			}
			.main-plate{
				font-size 14px
			}
			.weui-cell_select-after{
				display flex
				/*justify-content space-between*/
			}
			.weui-cell_park{
				.weui-cell__bd:after{
					width 0
					height: 0;
				}
			}
		}
		.user-info{
			font-size 16px
			color #6d6d6d
			padding 10px 15px
			display flex
			/*justify-content space-around*/
		}
		.weui-btn-area{
			margin-top 50px
			.weui-btn_primary, .weui-btn_disabled{
				width 100%
			}
		}
	}
.weui-form-preview__item{
    display: flex;
	align-items: center;
    margin-top:10px;
	margin-left:-10px;
}
.color{
    color: #8b8080;
}
.weui-cell{
    padding:0;
}
</style>
